'use client';

import { Button, Spinner } from '@common/components';
import { cn } from '@core/utils';
import { useState } from 'react';

interface CommentFormProps {
  onSubmit?: (comment: string) => void;
  onChange?: (comment?: string) => void;
  onClose?: () => void;
  loading?: boolean;
  isEdit?: boolean;
  initialComment?: string;
}

export const CommentForm = ({
  onSubmit,
  onChange,
  onClose,
  loading,
  isEdit,
  initialComment,
}: CommentFormProps) => {
  const [comment, setComment] = useState(initialComment ?? '');

  const handleSubmit = () => {
    if (loading) return;

    setComment('');
    onSubmit?.(comment);
  };

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (e.target.value.length > 100) return;
    setComment(e.target.value);
    onChange?.(e.target.value);
  };

  const isDisabledSubmitButton = !comment.trim();
  const submitButtonText = isEdit ? '수정' : '등록';
  const isShowCancelButton = isEdit;

  return (
    <article
      className={cn(
        'relative flex w-full flex-col gap-8 rounded-small border border-Gray-300 px-16 py-12',
        {
          'pointer-events-none blur-sm': loading,
        },
      )}
    >
      <textarea
        className="min-h-80 resize-none text-Gray-900 outline-none placeholder:font-400 placeholder:text-Gray-550 placeholder:typo-body3"
        placeholder="응원의 말을 남겨주세요"
        value={comment}
        onChange={handleChange}
        maxLength={100}
      />

      <div className="flex items-end justify-between">
        <p className="font-400 text-Gray-550 typo-caption1">
          {comment.length}/100
        </p>
        <div className="flex items-center gap-4">
          {isShowCancelButton && (
            <Button
              theme="sub-fill"
              dimensions="H32"
              onClick={() => onClose?.()}
            >
              취소
            </Button>
          )}
          <Button
            theme="primary-fill"
            dimensions="H32"
            disabled={isDisabledSubmitButton}
            onClick={handleSubmit}
          >
            {submitButtonText}
          </Button>
        </div>
      </div>

      {loading && (
        <div className="absolute left-0 top-0 size-full bg-Gray-white/10 flex-center">
          <Spinner />
        </div>
      )}
    </article>
  );
};
